import { css } from "@emotion/react";

export const mainContainer = css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: #004F9E;
    box-shadow: 10px 10px 4px rgba(0,0,0,0.4);
    border-radius: 10px;
    border: 1px solid #004F9E;
    bottom: 12px;
    min-width: 160px;
    transform: translateX(-50%);
    opacity: 0.9;

    &::after, &::before {
        top: 100%;
        border: solid transparent;
        content: " ";
        left: 50%;
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    &::after {
        border-top-color: #004F9E;
        border-width: 10px;
        margin-left: -10px;
    }

    &::before {
        border-top-color: #004F9E;
        border-width: 11px;
        margin-left: -11px;
    }
`

export const top = css`

`

export const closer = css`
    font-size: 16px;
    color: #ffffff;
    text-decoration: none;
    position: absolute;
    top: 3px;
    right: 7px;
    cursor: pointer;
`

export const content = css`
    display: flex;
    width: 100%;
    align-self: flex-start;
    justify-content: flex-start;
    padding: 10px 10px 20px 10px;
    flex-direction: column;
    white-space: nowrap;
`

export const header = css`
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 15px;
    color: #ffffff;
    padding-right: 15px;
`

export const name = css`
    font-size: 13px;
    padding-bottom: 5px;
    color: #ffffff;
    
    text-align: right;
`

export const text = css`
    font-size: 12px;
    color: #ffffff;
    
    text-align: right;
`
